import { AES, enc } from "crypto-js";
const jwtToken: any = process.env.REACT_APP_JWT_TOKEN_SECRET;
// var key = CryptoJS.enc.Utf8.parse(jwtToken);
// var iv = CryptoJS.enc.Utf8.parse(jwtToken);
const cryptoHelper = {
  generatePassword(data: string) {
    return AES.encrypt(data, jwtToken).toString();
  },

  getPassword(data: string) {
    return AES.decrypt(data, jwtToken).toString(enc.Utf8);
  },
};

export default cryptoHelper;
